import { render } from "./DefFade.vue?vue&type=template&id=99f36dc4&scoped=true"
import script from "./DefFade.vue?vue&type=script&lang=js"
export * from "./DefFade.vue?vue&type=script&lang=js"

import "./DefFade.vue?vue&type=style&index=0&id=99f36dc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f36dc4"]])

export default __exports__